import { BrandLoader } from '@/components/brand-loader';
import { ProgressBar } from 'antd-mobile';
import themeToken from '~theme-token';

export function SuspenseFallback() {
  return (
    <>
      <ProgressBar
        percent={38}
        style={{
          '--fill-color': themeToken.global.colorPrimary,
          '--track-width': '2px',
          position: 'fixed',
          top: 0,
          right: 0,
          left: 0,
          zIndex: 9999,
        }}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          background: '#f8f9fa',
        }}
      >
        <BrandLoader />
      </div>
    </>
  );
}
